import { object, string, number } from 'yup';

import { CreateService } from '../../../../types/service.type';

type FieldConfig = {
    key: keyof CreateService;
    label: string;
    placeholder: string;
    type: 'text' | 'number';
    required?: boolean;
};

export const createServiceFormSchema = object().shape({
    name: string().min(3).required(),
    code: string().min(1).required(),
    description: string().min(3).required(),
    totalFreeTowingServices: number().min(0).required(),
    totalFreeAmbulanceServices: number().min(0).required(),
    towingEligibilityDays: number().min(0).required(),
});

export const createServiceFields: FieldConfig[] = [
    {
        key: 'name',
        label: 'Nombre del servicio',
        placeholder: 'Ingrese el nombre del servicio',
        type: 'text',
    },
    {
        key: 'code',
        label: 'Código del servicio',
        placeholder: 'Ingrese el código del servicio',
        type: 'text',
    },
    {
        key: 'description',
        label: 'Descripción',
        placeholder: 'Ingrese una descripción del servicio',
        type: 'text',
        required: true,
    },
    {
        key: 'totalFreeTowingServices',
        label: 'Servicios de remolque gratuitos',
        placeholder: '0',
        type: 'number',
    },
    {
        key: 'totalFreeAmbulanceServices',
        label: 'Servicios de ambulancia gratuitos',
        placeholder: '0',
        type: 'number',
    },
    {
        key: 'towingEligibilityDays',
        label: 'Días de elegibilidad para remolque',
        placeholder: '0',
        type: 'number',
    },
];
